function parseCap(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.floor(n);
}

export function employeeLimitMessage(n) {
  return `Employee limit reached. Your company plan allows a maximum of ${n} employees.`;
}

export function essLimitMessage(n) {
  return `ESS user limit reached. Your company plan allows a maximum of ${n} ESS users.`;
}

function readCompanyCap(company, camelKey, snakeKey) {
  if (!company) return null;
  return parseCap(company[camelKey] ?? company[snakeKey]);
}

function readCount(company, camelKey, snakeKey) {
  if (!company) return 0;
  const n = Number(company[camelKey] ?? company[snakeKey] ?? 0);
  return Number.isFinite(n) ? n : 0;
}

export function getEmployeeCapError(company) {
  const cap = readCompanyCap(company, "maxEmployees", "max_employees");
  if (!cap) return null;
  const count = readCount(company, "employeeCount", "employee_count");
  if (count >= cap) return employeeLimitMessage(cap);
  return null;
}

export function getEssCapError(company) {
  const cap = readCompanyCap(company, "maxEssUsers", "max_ess_users");
  if (!cap) return null;
  const count = readCount(company, "essUserCount", "ess_user_count");
  if (count >= cap) return essLimitMessage(cap);
  return null;
}
